const ArrowRightCalendar = props => (
	<svg
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		className="flip-if-rlt"
	>
		<path
			d="M6.73828 20.23L8.50828 22L18.5083 12L8.50828 2L6.73828 3.77L14.9683 12L6.73828 20.23Z"
			fill="currentColor"
		/>
	</svg>
);

export default ArrowRightCalendar;
